import { ExcelService } from './../../../services/excel.service';
import { AuthService } from './../../../services/auth.service';
import { NgxRolesService } from 'ngx-permissions';
import { School } from './../../../models/school';
import { Observable } from 'rxjs/Observable';
import { DataTablesResponse } from './../../../models/DataTablesResponse';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { PassengerAutoNotif } from './../../../models/passenger-auto-notif';
import { Component, OnInit, OnDestroy, ViewChild, NgZone } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Select2OptionData } from 'ng2-select2';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { PNotifyService } from '../../../services/pnotify.service';

@Component({
  selector: 'app-passenger-auto-notif-datatable',
  templateUrl: './passenger-auto-notif-datatable.component.html',
  styleUrls: ['./passenger-auto-notif-datatable.component.css']
})
export class PassengerAutoNotifDatatableComponent implements OnInit, OnDestroy {

  filter = {
    clientId: '',
    schoolId: '',
    busId: '',
    passengerId: '',
    // alertId: '',
    dateInterval: '',
    isAdmin: false
  };
  staticFilter: any;

  clients: any[];
  schools: any[];
  buses: any[];
  passengers: any[];
  // alerts: any[];
  public clientsData: Array<Select2OptionData>;
  public schoolsData: Array<Select2OptionData>;
  public busesData: Array<Select2OptionData>;
  public passengersData: Array<Select2OptionData>;

  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;

  // ----- Start Option Scrollbar -----------
  isScrollbar: true;
  scrollbarOptions = {
    axis: 'y',
    theme: 'minimal-dark'
  };
  // ----- End Option Scrollbar -----------

  selectedAll = false;
  selectedMulti = false;
  pnotify = undefined;
  dtOptions: any = {};
  passengerAutoNotifs: any[];
  isResponsible = false;
  // ----- Start DatePicker -----------
  dateTimeFilterWE = (d: moment.Moment): boolean => {
    const day = d.day();
    // Prevent Saturday and Sunday from being selected.
    return day !== 0 && day !== 6;
  }
  // ----- End DatePicker -----------

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private roleService: NgxRolesService,
    private excelService: ExcelService,
    private router: Router,
    private zone: NgZone,
    pnotifyService: PNotifyService
  ) {
    this.filter.isAdmin = (this.roleService.getRole('ROLE_ADMIN')) ? true : false;
    this.initClientSelect();
    // this.initAlertSelect();
    this.pnotify = pnotifyService.getPNotify();
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      this.isResponsible = true;
    }
  }

  ngOnInit(): void {
    this.staticFilter = JSON.parse(JSON.stringify(this.filter));
    if (Array.isArray(this.staticFilter.dateInterval) &&
      this.staticFilter.dateInterval.length) {
      this.staticFilter.dateInterval = [
        moment(this.staticFilter.dateInterval[0]).format('YYYY-MM-DD'),
        moment(this.staticFilter.dateInterval[1]).format('YYYY-MM-DD')
      ];
    }
    this.dtOptions = {
      searching: false,
      pageLength: 5,
      serverSide: true,
      processing: true,
      lengthMenu: [[5, 10, 25, 50, 100], [5, 10, 25, 50, 100]],
      order: [[1, 'asc']],
      ordering: false,
      columnDefs: [
        { 'orderable': false, 'targets': 0 }
      ],
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.filter = this.staticFilter;
        this.http.post<DataTablesResponse>(
          '/api/passengerAutoNotif',
          dataTablesParameters,
          {}
        ).subscribe((resp: any) => {
          this.passengerAutoNotifs = resp.data;
          const dta = [];
          this.passengerAutoNotifs.forEach(passengerAutoNotif => {
            dta.push({
              id: passengerAutoNotif.id,
              checkbox: `<label class="el-switch" style="font-size:80%">
                          <input  type="checkbox"
                                  name="checkboxs[]"
                                  value="${passengerAutoNotif.id}"
                                  ${this.selectedAll ? 'checked' : ''}
                          >
                          <span class="el-switch-style"></span>
                        </label>`,
              schoolName: passengerAutoNotif.schoolName,
              busName: passengerAutoNotif.Passenger.Bus.name,
              passengerName: passengerAutoNotif.Passenger.lastname,
              date: moment(passengerAutoNotif.date).format('DD/MM/YYYYY à HH:mm'),
              message: passengerAutoNotif.message,
              actions: `
                <button class="btn btnAction btnDelete" data-passengerautonotif-id="${passengerAutoNotif.id}">
                  <i class="fa fa-trash fa-2x" aria-hidden="true"></i>Supprimer
                </button>
              `
            });
          });

          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: dta
          });
        });
      },
      fnCreatedRow: function (nRow, aData, iDataIndex) {
        $(nRow).attr('id', 'passengerAutoNotif_' + aData.id);
      },
      columns: [
        { data: 'checkbox' },
        { data: 'schoolName' },
        { data: 'busName' },
        { data: 'passengerName' },
        { data: 'date' },
        { data: 'message' },
        { data: 'actions' },
      ],
      dom: '<t> <"row" <"col-md-4"l><"col-md-8"p>>',
      language: {
        'sProcessing': 'Traitement en cours...',
        'sSearch': 'Rechercher&nbsp;:',
        'sLengthMenu': 'Afficher _MENU_ &eacute;l&eacute;ments',
        'sInfo': 'Affichage de l\'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments',
        'sInfoEmpty': 'Affichage de l\'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ment',
        'sInfoFiltered': '(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)',
        'sInfoPostFix': '',
        'sLoadingRecords': 'Chargement en cours...',
        'sZeroRecords': 'Aucun &eacute;l&eacute;ment &agrave; afficher',
        'sEmptyTable': 'Aucune donn&eacute;e disponible dans le tableau',
        'oPaginate': {
          'sFirst': 'Premier',
          'sPrevious': 'Pr&eacute;c&eacute;dent',
          'sNext': 'Suivant',
          'sLast': 'Dernier'
        },
        'oAria': {
          'sSortAscending': ': activer pour trier la colonne par ordre croissant',
          'sSortDescending': ': activer pour trier la colonne par ordre d&eacute;croissant'
        }
      },
      // Use this attribute to enable the responsive extension
      responsive: true
    };
    $('table').on('click', '.btnDelete', (event) => {
      this.onDelete($(event.currentTarget).data('passengerautonotifId'));
    });
    $('table').on('change', '[name="checkboxs[]"]', (event) => this.onCheckChange());
    $('table').on('draw.dt', (event) => this.onCheckChange());
  }

  initClientSelect() {
    if (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT')) {
      const client = this.authService.getUser();
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.initSchoolSelect();
    } else if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      const client = this.authService.getUser().School.Client;
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.initSchoolSelect();
    } else {
      this.http.get(
        '/api/client/lookup'
      ).subscribe((clients: any[]) => {
        this.clients = clients;
        const array1 = [{ id: '', text: 'Choisir un client' }];
        const array2 = this.clients.map(function (client, index) {
          return { id: client.id, text: client.name };
        });
        this.clientsData = array1.concat(array2);

        // this.initSchoolSelect();
      });
    }
    this.staticFilter = JSON.parse(JSON.stringify(this.filter));
    if (Array.isArray(this.staticFilter.dateInterval) &&
      this.staticFilter.dateInterval.length) {
      this.staticFilter.dateInterval = [
        moment(this.staticFilter.dateInterval[0]).format('YYYY-MM-DD'),
        moment(this.staticFilter.dateInterval[1]).format('YYYY-MM-DD')
      ];
    }
  }

  clientChanged(e: any) {
    this.filter.clientId = e.value;
    this.initSchoolSelect();
  }

  initSchoolSelect() {
    this.filter.schoolId = '';
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId
      }
    });
    this.http.get(
      '/api/school/lookup',
      { params }
    ).subscribe((schools: any[]) => {
      // this.filter.schoolId = schools.length ? schools[0].id : '';
      this.schools = schools;
      const array1 = [{ id: '', text: 'Choisir une école' }];
      const array2 = this.schools.map((school, index) => {
        if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
          return {
            id: school.id,
            text: school.name,
            selected: (this.authService.getUser().School.id === school.id) ? true : false
          };
        } else {
          return { id: school.id, text: school.name };
        }
      });
      this.schoolsData = array1.concat(array2);
      this.busesData = [{ id: '', text: 'Choisir un bus' }];

      // this.initBusSelect();
    });
  }
  schoolChanged(e: any) {
    this.filter.schoolId = e.value;
    this.initBusSelect();
  }

  initBusSelect() {
    this.filter.busId = '';
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId,
        schoolId: this.filter.schoolId
      }
    });
    this.http.get(
      '/api/bus/lookup',
      { params }
    ).subscribe((buses: any[]) => {
      // this.filter.busId = buses.length ? buses[0].id : '';
      this.buses = buses;
      const array1 = [{ id: '', text: 'Choisir un bus' }];
      const array2 = this.buses.map(function (bus, index) {
        return { id: bus.id, text: bus.name };
      });
      this.busesData = array1.concat(array2);
      this.passengersData = [{ id: '', text: 'Choisir un parent' }];

      // this.initPassengerSelect();
    });
  }
  busChanged(e: any) {
    this.filter.busId = e.value;
    this.initPassengerSelect();
  }

  initPassengerSelect() {
    this.filter.passengerId = '';
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId,
        schoolId: this.filter.schoolId,
        busIds: JSON.stringify([this.filter.busId]),
        isAssistant: 'false',
        isActive : 'true',
      }
    });
    this.http.get(
      '/api/passenger/lookup',
      { params }
    ).subscribe((passengers: any) => {
      // this.filter.passengerId = passengers.length ? passengers[0].id : '';
      this.passengers = passengers.rows;
      const array1 = [{ id: '', text: 'Choisir un parent' }];
      const array2 = this.passengers.map(function (passenger, index) {
        return { id: passenger.id, text: passenger.lastname };
      });
      this.passengersData = array1.concat(array2);
    });
  }
  passengerChanged(e: any) {
    this.filter.passengerId = e.value;
  }

  // initAlertSelect() {
  //   this.filter.alertId = '';
  //   let params = new HttpParams({
  //     fromObject: {
  //       isAdmin: this.filter.isAdmin + ''
  //     }
  //   });
  //   this.http.get(
  //     '/api/alert/lookup',
  //     { params }
  //   ).subscribe((alerts: any[]) => {
  //     this.alerts = alerts;
  //   });
  // }

  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();
    $('table').off();
  }

  onSelectedAllChange() {
    $('[name="checkboxs[]"]').prop('checked', this.selectedAll);
    this.onCheckChange();
  }

  onCheckChange() {
    const length = $('[name="checkboxs[]"]:checked').length;
    if (length > 1) {
      this.selectedMulti = true;
    } else {
      this.selectedMulti = false;
    }
  }

  onExport(id) {
    this.http.post(
      '/api/passengerAutoNotif',
      { filter: this.staticFilter }
    ).subscribe((resp: any) => {
      const data = [
        [
          'École',
          'Bus',
          'Parent',
          // 'Type d\'alerte',
          'Date',
          'Message'
        ]
      ];
      for (let i = 0; i < resp.data.length; i++) {
        data.push([
          resp.data[i].schoolName,
          resp.data[i].Passenger.Bus.name,
          resp.data[i].Passenger.lastname,
          // resp.data[i].Alert.name,
          resp.data[i].date,
          resp.data[i].message
        ]);
      }
      this.excelService.exportAsExcelFile(data, 'alertes_parents');
    });
  }

  onDelete(id) {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous supprimer cet element ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                this.delete(id);
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  onBulkDelete() {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous supprimer la selection ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                $('[name="checkboxs[]"]:checked').each((i, elt: any) => {
                  this.delete($(elt).val());
                });
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  delete(id) {
    this.http
      .delete('/api/passengerAutoNotif/' + id)
      .subscribe(
        result => {
          document.getElementById('passengerAutoNotif_' + id).remove();
        },
        error => {
          this.pnotify.error({
            title: 'Erreur',
            text: 'Une erreur est survenue !',
            stack: {
              firstpos1: 70, firstpos2: 10,
              modal: true,
              overlay_close: true
            },
            hide: false,
            modules: {
              Confirm: {
                confirm: true,
                buttons: [
                  {
                    text: 'Ok',
                    addClass: 'btn btn-chico',
                    click: notice => {
                      notice.close();
                    }
                  }
                ]
              }
            }
          });
        }
      );
  }

  onFilter(): void {
    this.staticFilter = JSON.parse(JSON.stringify(this.filter));
    if (Array.isArray(this.staticFilter.dateInterval) &&
      this.staticFilter.dateInterval.length) {
      this.staticFilter.dateInterval = [
        moment(this.staticFilter.dateInterval[0]).format('YYYY-MM-DD'),
        moment(this.staticFilter.dateInterval[1]).format('YYYY-MM-DD')
      ];
    }
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.draw();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/passenger-auto-notif/passenger-auto-notif-datatable/passenger-auto-notif-datatable.component.ts